/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ResumeTreatmentPlan/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import Tysiav2MedicalReportClipboard from 'DesignSystem/Svgs/Tysiav2MedicalReportClipboard/index'



/** @type {import('Simple/types.js').View} */
export default function ResumeTreatmentPlan({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Summary/Content/Content/TreatmentPlanStatus/Content/Content/Icon/ResumeTreatmentPlan"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<Tysiav2MedicalReportClipboard
  viewPath={`${viewPath}/Tysiav2MedicalReportClipboard`}
 fill2="#724BB7"
 marginLeft={dtSpaceXs}
 marginRight={dtSpaceXs}
 width={16}
 height={16}
/>
{children}
</React.Fragment>)
}